module.exports = __webpack_public_path__ + "static/media/Lope.ff072e67.jpeg";